// @flow
import React from 'react';
import { MdDelete } from 'react-icons/md';
import { fromNow } from 'lib/common';
import { Link } from 'react-router-dom';

import './SaveProductCard.scss';

type Props = {
  thumbnail: ?string,
  id: string,
  title: string,
  updatedAt: string,
  onAskRemove: (productId: string) => void,
};

const SaveProductCard = ({ id, thumbnail, title, updatedAt, onAskRemove }: Props) => (
  <div className="SaveProductCard">
    {thumbnail && (
      <div className="img-wrapper">
        <img src={thumbnail} alt="thumbnail" />
      </div>
    )}
    <div className="white-area">
      <div className="product-info">
        <h3>
          <Link to={`/write?edit_id=${id}&type=product`}>{title}</Link>
        </h3>
        <div className="date">{fromNow(updatedAt)}</div>
      </div>
      <button className="remove-button" onClick={() => onAskRemove(id)}>
        <MdDelete />
      </button>
    </div>
  </div>
);

export default SaveProductCard;



// WEBPACK FOOTER //
// ./src/components/saves/SaveProductCard/SaveProductCard.js